import { observer } from 'mobx-react-lite'
import { type SubmissionViewModel } from '@/features/jobs/drafting/SubmissionViewModel'
import { SummaryContainer } from '@/features/jobs/drafting/components/JobCreation/Summary/SummaryContainer'
import { SubmissionContainer } from '@/features/jobs/drafting/components/JobCreation/Submission/SubmissionContainer'
import { FormSubmission } from '@/features/jobs/drafting/components/JobCreation/JobCreationFormView/FormSubmission'

export interface FormSubmissionContainerProps {
  vm: SubmissionViewModel
}

export const FormSubmissionContainer = observer(
  function FormSubmissionContainer({ vm }: FormSubmissionContainerProps) {
    return (
      <FormSubmission
        summary={<SummaryContainer vm={vm} />}
        submission={<SubmissionContainer vm={vm} />}
      />
    )
  },
)
